var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04035 10.6057C8.40746 11.097 8.87582 11.5035 9.41367 11.7976C9.95152 12.0918 10.5463 12.2667 11.1576 12.3105C11.7689 12.3543 12.3825 12.266 12.9567 12.0516C13.531 11.8372 14.0524 11.5016 14.4857 11.0678L17.0502 8.5007C17.8288 7.69378 18.2596 6.61304 18.2498 5.49125C18.2401 4.36946 17.7906 3.29638 16.9981 2.50312C16.2057 1.70987 15.1337 1.25991 14.013 1.25016C12.8924 1.24041 11.8127 1.67166 11.0066 2.451L9.53629 3.91423M11.4597 8.89431C11.0925 8.40304 10.6242 7.99654 10.0863 7.7024C9.54848 7.40825 8.95373 7.23333 8.3424 7.1895C7.73108 7.14568 7.11749 7.23397 6.54326 7.44839C5.96902 7.66282 5.44757 7.99835 5.01427 8.43224L2.4498 10.9993C1.67123 11.8062 1.24042 12.887 1.25016 14.0088C1.2599 15.1305 1.7094 16.2036 2.50186 16.9969C3.29432 17.7901 4.36632 18.2401 5.48698 18.2498C6.60765 18.2596 7.6873 17.8283 8.49341 17.049L9.95516 15.5858",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkPin);
export default __webpack_public_path__ + "static/media/LinkPin.2fd6e1861a6243f93d407c59a4691887.svg";
export { ForwardRef as ReactComponent };